import { render, staticRenderFns } from "./TxGaslessIcon.vue?vue&type=template&id=98651224"
import script from "./TxGaslessIcon.vue?vue&type=script&lang=js"
export * from "./TxGaslessIcon.vue?vue&type=script&lang=js"
import style0 from "./TxGaslessIcon.vue?vue&type=style&index=0&id=98651224&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports